import { useQuery } from '@tanstack/react-query';

import type { SubscriberReferrals } from '~/interfaces/subscriber_referrals';

export const subscriberReferralsKeys = {
  all: ['subscriber-referrals'] as const,
  bySubscriber: (subscriberId: string) => ['subscriber-referrals', subscriberId] as const,
};

const fetchSubscriberReferrals = async (subscriberId: string): Promise<SubscriberReferrals> => {
  const response = await fetch(`/subscriber_referrals?subscriber_id=${subscriberId}`);
  if (!response.ok) throw new Error('Failed to fetch subscriber referrals');
  return response.json();
};

interface Props {
  enabled: boolean;
  subscriberId: string;
}

interface ReturnProps {
  isLoading: boolean;
  data?: SubscriberReferrals;
  enabled?: boolean;
}

const useStaticSubscriptionReferrals = ({ enabled, subscriberId }: Props): ReturnProps => {
  const { data, isLoading } = useQuery({
    queryKey: subscriberReferralsKeys.bySubscriber(subscriberId),
    queryFn: () => fetchSubscriberReferrals(subscriberId),
    enabled: enabled && !!subscriberId,
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnWindowFocus: false,
  });

  return {
    isLoading: isLoading && enabled,
    data: data ?? undefined,
  };
};

export default useStaticSubscriptionReferrals;
